"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _view = _interopRequireDefault(require("@react-x/view"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var DropdownContent = function DropdownContent(_ref) {
  var isVisible = _ref.isVisible,
      height = _ref.height,
      children = _ref.children,
      style = _ref.style;
  return _react["default"].createElement(_view["default"], {
    style: {
      display: isVisible ? 'flex' : 'none'
    }
  }, _react["default"].createElement(_view["default"], {
    style: _objectSpread({
      position: 'absolute',
      top: 0,
      right: 0,
      overflowY: 'auto',
      zIndex: 100
    }, height ? {
      maxHeight: height
    } : {}, {}, style)
  }, children));
}; // --------------------------------------------------
// Props
// --------------------------------------------------


DropdownContent.propTypes = {
  height: _propTypes["default"].number,
  style: _propTypes["default"].object
};
DropdownContent.defaultProps = {
  height: null,
  style: {}
};
var _default = DropdownContent;
exports["default"] = _default;